import React from 'react';
import {useBrand} from '@/contexts/BrandContext';
import Box from '@mui/material/Box';
import {useNavigate} from 'react-router-dom';
import {useTheme} from '@mui/material';

const isChristmasPeriod = () => {
  const today = new Date();
  const month = today.getMonth();
  const day = today.getDate();

  return month === 11 && day >= 10 && day <= 31;
};

const MainLogo: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const {name: brandName, assets} = useBrand();

  const logoSrc = isChristmasPeriod() ? assets.logoChristmas : assets.logo;
  return (
    <Box
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <img
        style={{
          height: 28,
          marginTop: 6,
        }}
        src={theme.palette.mode === 'light' ? logoSrc : assets.logoDark}
        alt={brandName}
        onClick={() => navigate('/')}
      />
    </Box>
  );
};

export default MainLogo;
